import { render, staticRenderFns } from "./dictaHeader.vue?vue&type=template&id=008e29fc"
import script from "./dictaHeader.vue?vue&type=script&lang=js"
export * from "./dictaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports